import { render, staticRenderFns } from "./PatientFormHealthInformation.vue?vue&type=template&id=4c41a444"
import script from "./PatientFormHealthInformation.vue?vue&type=script&lang=js"
export * from "./PatientFormHealthInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports